import BaseFooter from './BaseFooter';
import FooterMobileApps from './FooterMobileApps';

const Footer = (props: { footer: FrontendFooter }) => {
    const { footer } = props;

    return (
        <BaseFooter footer={props.footer}>
            {footer.footerShowDownloadApp && (
                <FooterMobileApps
                    downloadAppAndroidUrl={footer.downloadAppAndroidUrl}
                    downloadAppIOSUrl={footer.downloadAppIOSUrl}
                    downloadAppQRImage={footer.downloadAppQRImage}
                    downloadAppQRImageAltText={footer.downloadAppQRImageAltText}
                />
            )}
        </BaseFooter>
    );
};

export default Footer;
